
<template>
    <div v-if="status === 'loading'">
        <a-icon icon="Spinner" />
    </div>
    <div v-else class="o-deficiencies__list">
        <m-tabs
            v-if="group"
            :items="list"
            :selected="group.id"
            class=""
            @input="selectActiveGroup($event)"
        />
        <div class="l-row o-list">
            <div class="l-row__column m-list">
                <template v-if="group && group.deficiencies && group.deficiencies.length">
                    <div
                    @click="$router.push({name: 'deficienciesItem', params:{id: deficiencies.id}})"
                     v-for="deficiencies in group.deficiencies"
                      :key="deficiencies.id"
                       class="m-list__item o-deficiencies__listItem">
                       <div class="m-list__itemPhoto">
                       <a-icon

                        icon="Crops"
                    />
                    </div>
                     <p class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize">{{deficiencies.element_name}}</p>
                    </div>
                </template>
                <p v-else>Brak informacji do wyświetlenia</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'deficienciesList',
    data() {
        return {}
    },
    computed: {
        status() {
            return this.$store.getters['deficiencies/status']
        },
        query() {
            return this.$store.getters.agrofagsQuery
        },
        agrofagTypes() {
            return this.$store.getters.agrofagTypes
        },
        list() {
            return this.$store.getters['deficiencies/list']
        },
        group() {
            return this.$store.getters['deficiencies/group']
        }
    },

    methods: {
        selectActiveGroup(group) {
            this.$store.dispatch('deficiencies/selectGroup', group)
        }
    },
    async created() {
        await this.$store.dispatch('deficiencies/fetchCropGroups')
    }
}
</script>